module.exports = "<!-- ko template: { name: 'survey-question-title-content', data: element } --><!--/ko-->\n<!-- ko if: element.isCollapsed || element.isExpanded -->\n<span\n    data-bind=\"css: getIconClass(), event: { keyup: element.toggleStateByKeyUp }, attr:{'aria-expanded': element.isCollapsed ? 'false': 'true'}\"\n    tabindex=\"0\"></span>\n<!-- /ko -->";


//////////////////
// WEBPACK FOOTER
// ./src/knockout/components/default-title/default-title.html
// module id = 114
// module chunks = 0